import { useMatchMedia } from '@betterment/js-runtime';
import { ContentLayoutF } from '@betterment/samba-react';
import { vstack } from '@betterment/samba-styled-system/patterns';
import { ErrorBoundary } from '@betterment/shared-components';

import ArticlesCard from './articles-card/ArticlesCard';
import { HomeMessageCard } from './braze-components/HomeMessageCard';
import { EnvelopesCard } from './envelopes-card/EnvelopesCard';
import { ExternalAccountsCard } from './external-accounts-card/ExternalAccountsCard';
import Header from './header/header';
import HomeModal from './home-modal/HomeModal';
import NetWorthCard from './net-worth/NetWorthCard';
import NetWorthAndPerformance from './net-worth-and-performance/NetWorthAndPerformance';
import PerformanceCard from './performance-card/PerformanceCard';
import { ProductOnboardingCrossSellCard } from './product-onboarding-cross-sell-card/ProductOnboardingCrossSellCard';
import { ProductOnboardingInProgressCard } from './product-onboarding-in-progress-card/ProductOnboardingInProgressCard';
import { ProductOnboardingIntentsCard } from './product-onboarding-intents-card/ProductOnboardingIntentsCard';
import { ProductOnboardingNotInProgressCard } from './product-onboarding-not-in-progress-card/ProductOnboardingNotInProgressCard';
import RewardsCard from './rewards-card/RewardsCard';
import { ScheduledTransactionsCard } from './scheduled-transactions-card/ScheduledTransactionsCard';
import { TransitionaryGoalsCard } from './transitionary-goals/TransitionaryGoalsCard';

import { ApplicationLayout } from '../Shared/layout/ApplicationLayout';

export default function Home() {
  const isLargeScreen = useMatchMedia('atLeastMedium');
  const isSmallScreen = !isLargeScreen;

  return (
    <ApplicationLayout pageTitle="Home" feature="home">
      <ApplicationLayout.Header>
        <ErrorBoundary fallbackType="inline">
          <Header />
        </ErrorBoundary>
      </ApplicationLayout.Header>
      <ApplicationLayout.Content>
        <ContentLayoutF>
          <ContentLayoutF.SlotContainer>
            <ContentLayoutF.Slot1
              css={{
                display: 'grid',
                gap: ['space.100', 'space.200'],
              }}
            >
              {isSmallScreen && <NetWorthAndPerformance />}
              {isSmallScreen && (
                <ErrorBoundary fallbackType="inline">
                  <ProductOnboardingInProgressCard />
                </ErrorBoundary>
              )}
              <ErrorBoundary fallbackType="inline">
                <HomeMessageCard location="summaryLegalBanner" />
              </ErrorBoundary>
              <ErrorBoundary fallbackType="inline">
                <HomeMessageCard location="summaryGuide" />
              </ErrorBoundary>
              <ErrorBoundary fallbackType="inline">
                <ProductOnboardingIntentsCard />
              </ErrorBoundary>
              {isLargeScreen && (
                <ErrorBoundary fallbackType="inline">
                  <ProductOnboardingInProgressCard />
                </ErrorBoundary>
              )}
              <ErrorBoundary fallbackType="inline">
                <ProductOnboardingNotInProgressCard />
              </ErrorBoundary>
              <ErrorBoundary fallbackType="inline">
                <EnvelopesCard />
              </ErrorBoundary>
              <ErrorBoundary fallbackType="inline">
                <TransitionaryGoalsCard />
              </ErrorBoundary>
              <ErrorBoundary fallbackType="inline">
                <ProductOnboardingCrossSellCard />
              </ErrorBoundary>
              <ErrorBoundary fallbackType="inline">
                <ExternalAccountsCard />
              </ErrorBoundary>
              {isSmallScreen && (
                <>
                  <ErrorBoundary fallbackType="inline">
                    <RewardsCard />
                  </ErrorBoundary>
                  <ErrorBoundary fallbackType="inline">
                    <ScheduledTransactionsCard />
                  </ErrorBoundary>
                </>
              )}
              <ErrorBoundary fallbackType="inline">
                <ArticlesCard />
              </ErrorBoundary>
            </ContentLayoutF.Slot1>
            <ContentLayoutF.Slot2
              css={{
                ...vstack.raw({ gap: 'space.200', alignItems: 'stretch' }),
              }}
            >
              {isLargeScreen && (
                <>
                  <ErrorBoundary fallbackType="inline">
                    <NetWorthCard />
                  </ErrorBoundary>
                  <ErrorBoundary fallbackType="inline">
                    <PerformanceCard />
                  </ErrorBoundary>
                  <ErrorBoundary fallbackType="inline">
                    <RewardsCard />
                  </ErrorBoundary>
                  <ErrorBoundary fallbackType="inline">
                    <ScheduledTransactionsCard />
                  </ErrorBoundary>
                  <ErrorBoundary fallbackType="inline">
                    <HomeMessageCard location="summarySecondaryCard" />
                  </ErrorBoundary>
                  <ErrorBoundary fallbackType="inline">
                    <HomeMessageCard location="summaryOverlayNotice" />
                  </ErrorBoundary>
                </>
              )}
            </ContentLayoutF.Slot2>
          </ContentLayoutF.SlotContainer>
        </ContentLayoutF>

        <HomeModal />
      </ApplicationLayout.Content>
    </ApplicationLayout>
  );
}
